import React from 'react';
import ReactDOM from "react-dom/client";
import App from './components/App.tsx';
import './index.scss';
import * as ServiceWorker from './ServiceWorker';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);
ServiceWorker.unregister();
